__turbopack_context__.v({
  "explanation": "SalesPrices-module-scss-module__7POjta__explanation",
  "header": "SalesPrices-module-scss-module__7POjta__header",
  "modal": "SalesPrices-module-scss-module__7POjta__modal",
  "sales-section": "SalesPrices-module-scss-module__7POjta__sales-section",
});
